export const userSource = [
    {
        id: '1',
        email: 'peter.seibel@gmail.com',
        firstName: "Alexandria",
        lastName: "Seibel",
        alumni: "No",
        membership: "Limited",
        purchasedOn: "09/12/2021",
        expiresOn: "10/12/2021",
        lastLoggedOn: "09/21/2021",
        addedOn: "09/01/2021",
        isVerified: false,
    },
    {
        id: '2',
        email: 'Macy_Victor7667@cispeto.com',
        firstName: "Peter",
        lastName: "Seibel",
        alumni: "Yes",
        membership: "Limited",
        purchasedOn: "09/12/2021",
        expiresOn: "10/12/2021",
        lastLoggedOn: "09/21/2021",
        addedOn: "09/01/2021",
        isVerified: true,
    },
    {
        id: '3',
        email: 'Peter_Gibbons6873@hourpy.biz',
        firstName: "Peter",
        lastName: "Gibbons",
        alumni: "No",
        membership: "Limited",
        purchasedOn: "09/12/2021",
        expiresOn: "10/12/2021",
        lastLoggedOn: "09/21/2021",
        addedOn: "09/01/2021",
        isVerified: false,
    },
    {
        id: '4',
        email: 'Joseph_Myatt2714@twace.org',
        firstName: "Joseph",
        lastName: "Myatt",
        alumni: "Yes",
        membership: "Limited",
        purchasedOn: "09/12/2021",
        expiresOn: "10/12/2021",
        lastLoggedOn: "09/21/2021",
        addedOn: "09/01/2021",
        isVerified: true,
    },
    {
        id: '5',
        email: 'Harvey_Morley3130@grannar.com',
        firstName: "Harvey",
        lastName: "Morley",
        alumni: "No",
        membership: "Limited",
        purchasedOn: "09/12/2021",
        expiresOn: "10/12/2021",
        lastLoggedOn: "09/21/2021",
        addedOn: "09/01/2021",
        isVerified: false,
    },
    {
        id: '6',
        email: 'Rhea_Camden8433@deons.tech',
        firstName: "Rhea",
        lastName: "Camden",
        alumni: "Yes",
        membership: "Limited",
        purchasedOn: "09/12/2021",
        expiresOn: "10/12/2021",
        lastLoggedOn: "09/21/2021",
        addedOn: "09/01/2021",
        isVerified: true,
    },
    {
        id: '7',
        email: 'Alma_Rodwell1478@bretoux.com',
        firstName: "Alma",
        lastName: "Rodwe",
        alumni: "No",
        membership: "Limited",
        purchasedOn: "09/12/2021",
        expiresOn: "10/12/2021",
        lastLoggedOn: "09/21/2021",
        addedOn: "09/01/2021",
        isVerified: false,
    },
    {
        id: '8',
        email: 'Denis_Uddin2203@gompie.com',
        firstName: "Denis",
        lastName: "Uddin",
        alumni: "Yes",
        membership: "Limited",
        purchasedOn: "09/12/2021",
        expiresOn: "10/12/2021",
        lastLoggedOn: "09/21/2021",
        addedOn: "09/01/2021",
        isVerified: true,
    }, {
        id: '9',
        email: 'Eduardo_Turner1564@elnee.tech',
        firstName: "Eduardo",
        lastName: "Turner",
        alumni: "No",
        membership: "Limited",
        purchasedOn: "09/12/2021",
        expiresOn: "10/12/2021",
        lastLoggedOn: "09/21/2021",
        addedOn: "09/01/2021",
        isVerified: false,
    },
    {
        id: '10',
        email: 'Marvin_Fowler5247@twipet.com',
        firstName: "Marvin",
        lastName: "Fowler",
        alumni: "Yes",
        membership: "Limited",
        purchasedOn: "09/12/2021",
        expiresOn: "10/12/2021",
        lastLoggedOn: "09/21/2021",
        addedOn: "09/01/2021",
        isVerified: true,
    },
    {
        id: '11',
        email: 'Adalie_Weston8931@bulaffy.com',
        firstName: "Adalie",
        lastName: "Weston",
        alumni: "No",
        membership: "Limited",
        purchasedOn: "09/12/2021",
        expiresOn: "10/12/2021",
        lastLoggedOn: "09/21/2021",
        addedOn: "09/01/2021",
        isVerified: false,
    },
    {
        id: '12',
        email: 'Lucy_Larsen7913@womeona.net',
        firstName: "Lucy",
        lastName: "Larsen",
        alumni: "Yes",
        membership: "Limited",
        purchasedOn: "09/12/2021",
        expiresOn: "10/12/2021",
        lastLoggedOn: "09/21/2021",
        addedOn: "09/01/2021",
        isVerified: true,
    },
];

export const courseSource = [
    {
        id: '1',
        course: 'Understanding User Experience for New Age IT',
        skill: "Corporate Leadership",
        instructor: "Roger Federer",
        addedOn: "09/12/2021",
        status: "Disabled",
        tags: ["Design Thinking", "Information Technology", "Media Innovation"],
    },
    {
        id: '2',
        course: 'Understanding User Experience for New Age IT',
        skill: "Corporate Leadership",
        instructor: "Roger Federer",
        addedOn: "09/12/2021",
        status: "Disabled",
        tags: ["Design Thinking", "Information Technology", "Media Innovation"],
    }
];

export const staticImg = "https://artoon-pinochle.s3.amazonaws.com/Skillup-USC/skill_up_9841631531996.png";